export const SearchQueryDelimiter = ",";
export const DownloadExtension = ".csv";
export const GenericErrorMessage =
	"Oops. That didn't work. Please try again or contact support if the issue persists";
export const ContainmentNameLength = 70;
export const ContainmentDescriptionLength = 200;
export const PartNumberMaxLength = 80;
export const SupplierPlant = "Suppliers";
export const EmptyCell = "[EMPTY_CELL]";
//eslint-disable-next-line  @typescript-eslint/naming-convention
export const UserProfileImageUrl = "https://peoplefinder.gm.com/Photos";
export const RESS = "RESS";
export const GPS = "GPS";
export const Flexnet = "Flexnet";
export const ASRS = "ASRS";
export const SourceSystemAsrs = "ASRS-LPN containment";
export const SourceSystemFlexnet = "Flexnet containment";
export const PlantStatusFlexnetTitle = "Plant Status (Flexnet)";
export const LpnLockingStatusTitle = "LPN Locking Status";


export const FlexnetHoldSystemId = "0863e559-2795-4659-9d91-37e715df87f2";
export const AsrsHoldSystemId = "64d9baae-5353-4d03-90d3-4cb2303743be";
export const AlreadySectorAdminMessage = "This user is already a Sector Admin. To add or change their sectors, find their row and click Edit.";

// ASRS templates omit Product Number (SITMP-7232 / SITMP-7233). Blob files via Deployment.
export const LpnUploadTemplate = "MCC_LPN_UPLOAD_TEMPLATE.xlsx";
export const UltiumSerialUploadTemplate = "MCC_ULTIUM_SERIAL_UPLOAD_TEMPLATE.xlsx";

// FlexNet create-flow templates: with PN = Part|Serial; SERIAL_ = Serial-only (PN removal).
export const GpsUploadTemplate = "MCC_GPS_UPLOAD_TEMPLATE.xlsx";
export const RessUploadTemplate = "MCC_RESS_UPLOAD_TEMPLATE.xlsx";
export const GpsSerialUploadTemplate = "MCC_GPS_SERIAL_UPLOAD_TEMPLATE.xlsx";
export const RessSerialUploadTemplate = "MCC_RESS_SERIAL_UPLOAD_TEMPLATE.xlsx";

export const UploadContentTypeLPN = "With LPN List";
export const UploadContentTypeSerial = "With Ultium Serial Number List";
